<template>
  <svg
    :viewBox="viewBox"
    :width="size"
    :height="size"
    :fill="inheritFill ? 'currentColor' : 'none'"
    role="presentation"
    :class="$style.svgIcon"
    v-bind="svgAttrs"
    @click="$emit('onClick', $event)"
    v-html="icon"
  />
</template>
<script>

export default {
  name: 'SvgSprite',
  inheritAttrs: false,
  props: {
    name: {
      type: String,
      required: false,
      default: '',
    },
    type: {
      type: String, // regular, bold, color-bold, color-regular
      required: false,
      default: 'regular',
    },
    size: {
      type: Number, // 16, 20, 24
      required: false,
      default: 24,
    },
    inheritFill: {
      type: Boolean,
      required: false,
      default: false,
    },

  },
  emits: [
    'onClick',
  ],
  data() {
    return {
    };
  },
  computed: {
    viewBox() {
      return `0 0 ${this.size} ${this.size}`;
    },
    svgAttrs() {
      return this.$attrs;
    },
    icon() {
      const hrefForSvg = `${this.type}/${this.size}/${this.name}`;

      return `<use
            xmlns:xlink="http://www.w3.org/1999/xlink"
            xlink:href="#icons/${hrefForSvg}"
            href="#icons/${hrefForSvg}"
        ></use>`;
    },
  },
};
</script>
<style module lang="less" src="./styles/svgSprite.less"></style>
